export interface IQuery { }

export class CurrentUserQueryV1 implements IQuery {
	$type?: string = 'TCh.Domain.Integrations.Users.Queries.CurrentUserQueryV1, TCh.Domain.Integrations'


	constructor ()
	{
	}

	static matchType(query: any)	{
		return query.$type == 'TCh.Domain.Integrations.Users.Queries.CurrentUserQueryV1, TCh.Domain.Integrations'
	}

}

